<template>
  <nuttrema-layout-west-slide width="30%">
    <west-slide-left-navigation slot="navigation-top">
      <a :title="$t('label.cancel')" @click="$emit('close')">
        <nuttrema-iconica-sidebar-link icon="far fa-times" theme="white"></nuttrema-iconica-sidebar-link>
      </a>
    </west-slide-left-navigation>
    <!-- end ~ navigation-top -->
    <nuttrema-layout-west-three-vertical>
      <div slot="top-center" class="top--center__title">
        <span>{{ $t('label.program_reports') }}</span>
      </div>

      <template slot="center">
        <form-program-reports
          @submit="onEventSubmit"
          @cancel="onEventCancel"
          :ProgramSchedulesReport="ProgramSchedulesReport">
        </form-program-reports>
      </template>
    </nuttrema-layout-west-three-vertical>
  </nuttrema-layout-west-slide>
</template>

<script>
import { mapActions } from 'vuex';
import { PROGRAMS_KEYS } from 'constants/types';

import PageProps from 'components/mixins/page-props';
import FileSaver from 'file-saver';

import NuttremaLayoutWestSlide from 'components/ui/layout/nuttrema-layout-west-slide';
import WestSlideLeftNavigation from 'components/ui/west-slide-component/west-slide-left-navigation';
import NuttremaIconicaSidebarLink from 'components/ui/label/nuttrema-iconica-sidebar-link';

import NuttremaLayoutWestThreeVertical from 'components/ui/layout/nuttrema-layout-west-three-vertical';
import FormProgramReports from './form-program-reports';

export default {
  name: 'page-program-reports',
  mixins: [
    PageProps,
  ],
  props: {
    id: {
      required: false,
      default: null,
    },
  },
  data() {
    return {
      type: PROGRAMS_KEYS.diet,
    };
  },
  components: {
    FormProgramReports,
    NuttremaLayoutWestSlide,
    WestSlideLeftNavigation,
    NuttremaIconicaSidebarLink,
    NuttremaLayoutWestThreeVertical,
  },
  computed: {
    ProgramSchedulesReport() {
      return this.$store.getters.ProgramSchedulesReport(this.id);
    },
  },
  methods: {
    ...mapActions([
      'GetProgramSchedulesReport',
    ]),
    onEventCancel() {
      this.$emit('close');
    },
    onEventSubmit(data) {
      const action = data.action;
      const reportType = data.report_type;

      this.GetProgramSchedulesReport({
        id: this.id,
        type: this.type,
        query: { report_type: reportType },
      }).then((file) => {
        if (action === 'download') {
          const blob = new Blob([file], { type: 'application/pdf' });
          const fileName = `${this.$t('label.program_schedules_report', { id: this.id, report_type: reportType })}.pdf`;
          FileSaver.saveAs(blob, fileName);
        } else {
          const fileURL = (window.URL || window.webkitURL).createObjectURL(file, { type: 'application/pdf' });
          window.open(fileURL);
        }
      }).catch((error) => {
        console.error(error);
      });
    },
  },
  created() {
    this.$store.dispatch('InitProgramSchedulesReport', { id: this.id });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/programs/diets/details/download/page-program-reports.vue